import { inView } from "motion";

export class ServicesGraphic {
	constructor() {
		this.svg = document.querySelector(".services__svg");
		this.services = document.querySelectorAll(".service[data-highlight]");

		if (!this.svg || !this.services.length) return;

		this.services.forEach((service) => this.observeService(service));
	}

	observeService(service) {
		const paths = this.getPathsForService(service);
		if (!paths.length) return;

		// Trigger when section is vertically centered
		inView(
			service,
			() => {
				this.highlightPaths(paths);
				return () => this.resetPaths(paths);
			},
			{ margin: "-50% 0px -50% 0px" }
		);
	}

	getPathsForService(service) {
		const segments = service.dataset.highlight?.split(",").map((s) => s.trim());
		if (!segments?.length) return [];
		return segments.flatMap((id) => [
			...this.svg.querySelectorAll(`[data-segment="${id}"]`),
		]);
	}

	highlightPaths(paths) {
		paths.forEach((path) => (path.dataset.highlight = ""));
	}

	resetPaths(paths) {
		paths.forEach((path) => delete path.dataset.highlight);
	}
}
